"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CalendarClock, Info, ArrowDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
export default function EnquiryIntro() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 12
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: "easeOut"
      }
    }
  };
  return <section id="productenquiryintro" data-nav="light" className="w-full bg-background text-foreground border-b border-border py-12 md:py-16">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={containerVariants} className="flex flex-col gap-6">
          {/* Eyebrow / Industrial Spec Label */}
          <div className="flex items-center gap-2">
            <Badge variant="outline" className="rounded-none border-border bg-muted/50 px-2.5 py-1 font-mono text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
              PRODUCT ENQUIRY &amp; ORDER REQUEST
            </Badge>
          </div>

          {/* Primary H1 Heading */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground leading-[1.08]">
            Request a Quote or Start Your Order
          </h1>

          {/* Intro Description */}
          <div className="space-y-2">
            <p className="text-base sm:text-lg text-foreground/90 font-normal leading-relaxed max-w-3xl">
              Use this form when you are interested in purchasing a new mechanical bull, used mechanical bull, part or accessory. If you arrived from a product page, the product and current listed price should already appear below.
            </p>
          </div>

          {/* Industrial Notice / Callout Box */}
          <div role="note" aria-label="Order Preparation and Payment Schedule" className="mt-4 border border-border border-l-4 border-l-primary bg-card text-card-foreground p-5 sm:p-6 shadow-xs">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="mt-0.5 shrink-0 rounded-none bg-primary/10 p-2 text-primary">
                <CalendarClock className="size-5" aria-hidden="true" />
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <h2 className="font-serif text-lg sm:text-xl font-bold uppercase tracking-wide text-foreground">
                    Order Preparation &amp; Payment Schedule
                  </h2>
                </div>
                <p className="text-sm sm:text-base text-muted-foreground font-normal leading-relaxed">
                  Mechanical bulls are usually prepared and ready for scheduled shipping within approximately 2 weeks after we receive either the required deposit or full payment. If a deposit is paid, the remaining balance must be received in full before the scheduled shipping date.
                </p>
              </div>
            </div>
          </div>

          {/* Form cue indicator */}
          <div className="pt-2 flex items-center gap-2 text-xs font-mono text-muted-foreground uppercase tracking-wider">
            <Info className="size-3.5 text-primary shrink-0" aria-hidden="true" />
            <span>Complete required specifications and contact details below</span>
            <ArrowDown className="size-3.5 text-muted-foreground animate-bounce ml-1" aria-hidden="true" />
          </div>
        </motion.div>
      </div>
    </section>;
}